carouselMidia()

function carouselMidia() {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);

    document.querySelectorAll('.carousel-midia')?.forEach(car => {
        const dataCarousel = car.getAttribute('data-carousel');
        const txtSelect = `.carousel-midia[data-carousel="${dataCarousel}"]`;

        const carousel = `${txtSelect} .slider`;
        const controls = `${txtSelect} .slider-controls`;
        const contentCarousel = `${txtSelect} .list-carousel`;
        const itemCarousel = `${txtSelect} .slider-item`;
        const btnPrev = `${txtSelect} .control-left`;
        const btnNext = `${txtSelect} .control-right`;
        const controlsIndicator = `${txtSelect} .controls-indicators-carousel`;
        const autoPlay = car.getAttribute('auto-play') == 'true' ? true : false;
        const interval = parseInt(car.getAttribute('interval'));

        if(select(itemCarousel))
            initCarousel(carousel, controls, contentCarousel, itemCarousel, btnPrev, btnNext, controlsIndicator, autoPlay, interval);
        else
            return;
    })


    function initCarousel(carousel, controls, contentCarousel, itemCarousel, btnPrev, btnNext, controlsIndicator, autoPlay, interval) {
        let totalSlides = selectAll(itemCarousel).length;
        let currentSlide = 0;

        select(contentCarousel).style.width = `calc(100vw * ${totalSlides})`;
        if(select(controls)) select(controls).style.height = `${select(carousel).clientHeight}px`;
        selectAll(`${controlsIndicator} .btn-indicator-carousel`)?.forEach((btn, index) => btn.setAttribute('data-margin', index))

        if(autoPlay) setInterval(() => next(), interval);

        select(btnPrev)?.addEventListener('click', () => prev());
        select(btnNext)?.addEventListener('click', () => next());
        indicatorsControl();

        function indicatorsControl() {
            selectAll(`${controlsIndicator} .btn-indicator-carousel`)?.forEach(btn => {
                btn.addEventListener('click', ()=> {
                    currentSlide = btn.getAttribute('data-margin');
                    updateMargin()
                })
            })
        }

        function prev() {
            currentSlide--;
            if(currentSlide < 0) currentSlide = totalSlides - 1;
            updateMargin()
        }

        function next() {
            currentSlide++;
            if(currentSlide > (totalSlides - 1)) currentSlide = 0;
            updateMargin()
        }

        function updateMargin() {
            let sliderItemWidth = select(itemCarousel).clientWidth;
            let newMargin = (currentSlide * sliderItemWidth);
            select(contentCarousel).style.marginLeft = `-${newMargin}px`;
            select('.btn-indicator-carousel.active')?.classList.remove('active');


            selectAll(`${controlsIndicator} .btn-indicator-carousel.active`)?.forEach(indicator => indicator.classList.remove('active'));

            select(`.btn-indicator-carousel[data-margin="${currentSlide}"]`)?.classList.add('active');
            select(`${controlsIndicator} .btn-indicator-carousel[data-margin="${currentSlide}"]`)?.classList.add('active');
        }

        // Auto Resize Controls
        window.addEventListener('resize', () => {
            if(select(controls)) select(controls).style.height = `${select(carousel).clientHeight}px`;
            updateMargin()
        })
    }
}
